var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"pa-0 d-flex align-center"},[_c('code',{class:_vm.badgeClass},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.badgeText)+" ")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }